<template>
  <div class="echarts">
    <IEcharts :option="line" :loading="loading" @ready="onReady" @click="onClick" />
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
import { HTTP as IOTHTTP } from "../../../../store/actions";
import moment from "moment";

export default {
  name: "custom-chart",
  components: {
    IEcharts
  },
  props: ["data", "loading"],
  watch: {
    // watch it
    data: function(newVal, oldVal) {
      this.line.series = newVal.seriesData;
      this.line.xAxis[0].data = newVal.timeStamps;
      (this.line.yAxis = newVal.yAxisLabel),
        (this.line.title.text = newVal.title ? newVal.title : "no title");
      this.line.legend.data = this.computeLegendValues(newVal.seriesData);
    }
  },
  data: () => ({
    // initOpts: {
    //   renderer: 'svg'
    // },
    line: {
      title: {
        text: ""
      },
      tooltip: {
          trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        // trigger: "axis",
        // axisPointer: {
        //   // type: "cross",
        //   label: {}
        // },
        backgroundColor: "#6a7985",
        textStyle: {
          fontSize: 12
        }
      },
      legend: {
        type:"scroll",
        right: 0,
        data: [],
        textStyle: {
          color: "#7f8b94"
        }
      },
      toolbox: {
        top: 18,
        feature: {
          // dataZoom: {
          //   yAxisIndex: "none"
          // },
          // restore: {},
          // mark: {
          //   show: true
          // },
          // dataView: {
          //   show: true,
          //   readOnly: false
          // },
          magicType: {
            title: {
              line: "Line charts",
              bar: "Bar charts",
              stack: "Stacked charts",
              tiled: "Tiled charts"
            },
            show: true,
            type: ["line", "bar"]
          },
          restore: {
            title: "Refresh",
            show: true
          },
          saveAsImage: {
            title: "Save as image",
            show: true
          }
        }
      },
      // grid: {
      //   left: "3%",
      //   right: "4%",
      //   bottom: "3%",
      //   containLabel: true
      // },
      grid: {
        top: "20%",
        left: "1%",
        right: 0,
        bottom: "8%",
        containLabel: true
        // show: true,
        // backgroundColor: "#f5f4f0"
      },
      xAxis: [
        {
          // name: "x",
          minorTick: {
            show: true
          },
          axisLabel: {
            color: "#959490"
          },
          splitLine: {
            lineStyle: {
              color: "#000"
            }
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: "#000"
            }
          },
          // type: "category",
          // boundaryGap: false,
          // splitLine: {
          //   lineStyle: {
          //     color: "#999"
          //   }
          // },
          data: []
        }
      ],
      yAxis: [
        {
          type: "value",
          name: "kWh",
          min: 0,
          // max: 100,
          // interval: 10,
          splitNumber: 3,
          axisLabel: {
            formatter: "{value}",
            color: "#959490"
          },
          splitLine: {
            lineStyle: {
              color: "transparent"
            }
          }
        }
      ],
      dataZoom: [
        {
          // type: "slide",
          show: true,
          start: 30,
          end: 100
        },
        {
          type: "slider",
          show: true,
          start: 30,
          end: 100
        }
      ],
      series: []
    }
    /*
    line: {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          label: {
            show: true
          }
        }
      },
      toolbox: {
        show: true,
        feature: {
          mark: {
            show: true
          },
          dataView: {
            show: true,
            readOnly: false
          },
          magicType: {
            show: true,
            type: ["line", "bar"]
          },
          restore: {
            show: true
          },
          saveAsImage: {
            show: true
          }
        }
      },
      calculable: true,
      legend: {
        data: ["Growth", "Budget 2011", "Budget 2012"],
        itemGap: 5
      },
      grid: {
        top: "12%",
        left: "1%",
        right: "10%",
        containLabel: true
      },
      xAxis: [
        {
          type: "category"
          // data: [],
        }
      ],
      yAxis: [
        {
          type: "value",
          name: "Consumption",
          axisLabel: {
            // formatter: function(a) {
            //   a = +a;
            // return "hello";
            // return isFinite(a) ?
            //   echarts.format.addCommas(+a / 1000) :
            //   '';
            // }
          }
        }
      ],
      dataZoom: [
        {
          show: true,
          start: 94,
          end: 100
        },
        {
          type: "inside",
          start: 94,
          end: 100
        },
        {
          show: true,
          yAxisIndex: 0,
          filterMode: "empty",
          width: 30,
          height: "80%",
          showDataShadow: false,
          left: "93%"
        }
      ],
      series: [
        {
          name: "Consumption",
          type: "bar",
          itemStyle: {
            color: "#1a93ca"
          },
          data: []
        },
        {
          name: "Solar",
          type: "bar",
          itemStyle: {
            color: "#ffe9c9"
          },
          data: []
        }
      ]
    }
    */
  }),
  methods: {
    onClick(event, instance, ECharts) {
      console.log(arguments);
    },
    async onReady(instance, ECharts) {
      this.$emit("onReady");
    },
    computeLegendValues(arr) {
      console.log({"ARRAY": arr})
      if (!Array.isArray(arr)) return [];
      return arr.map(item => {
        return item.legend;
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.echarts {
  margin-top: 20px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customChart.vue